import React from "react";
import { Text, View } from "@react-pdf/renderer";
import Tr from "./Tr";
import Td from "./Td";

/**
 * This component is used to render the table body.
 * @param {object} props - The props object.
 * @param {object[]} props.headerData - The header data of the table.
 * @param {object[]} props.contentData - The content data of the table.
 * @param {number} props.fontSize - The font size of the table.
 * @param {number[]} props.widthArray - The width array of the table.
 * @param {number[]} props.breakArray - The break array of the table.
 * @param {object} props.breakStyle - The break style of the table.
 * @param {string[]} props.fontSizeArray - The font size array of the table.
 * @returns {JSX.Element} - The component JSX element.
 * @example
 * // The element of breakArray:
 * // [The first break point, The other break point]
 */
const Tbody = ({
  headerData,
  contentData,
  fontSize,
  widthArray,
  breakArray,
  breakStyle,
  fontSizeArray,
}) => {
  const trWidth = "99";
  const sum = Array.isArray(widthArray)
    ? widthArray.reduce((a, b) => a + b, 0)
    : 0;
  return (
    <View>
      {Array.isArray(contentData) &&
        contentData.map((element, index) => {
          return (
            <Tr
              key={"_id" in element ? element._id : index}
              index={index}
              length={contentData.length}
              breakArray={breakArray}
              breakStyle={breakStyle}
              keyTag={"_id" in element ? element._id : index.toString()}
            >
              {Array.isArray(headerData) &&
                headerData.map((headerItem, headerIndex) => {
                  return (
                    <Td
                      key={
                        "_id" in element
                          ? element._id + headerItem.columnKey
                          : headerIndex + headerItem.columnKey
                      }
                      isLeft={headerIndex === 0}
                      text={element[headerItem.columnKey]}
                      fontSize={
                        Array.isArray(fontSizeArray) &&
                        fontSizeArray[headerIndex]
                          ? fontSizeArray[headerIndex]
                          : fontSize
                      }
                      trWidth={trWidth}
                      withWeight={
                        Array.isArray(widthArray) && widthArray.length > 0
                          ? widthArray[headerIndex] / sum
                          : 0
                      }
                      index={index}
                      breakArray={breakArray}
                    />
                  );
                })}
            </Tr>
          );
        })}
    </View>
  );
};

export default Tbody;
